import { Api } from 'utils';

class AuthService {
	
	static login = async (params?: any) => Api.createResponse('auth/login',params);
	static checkCode = async (params?: any) => Api.createResponse('auth/check-code',params);
	static recover = async (params = {}) => Api.createResponse('auth/recover',params);
	static reset = async (params = {}) => Api.createResponse('auth/reset',params);
	static checkUser = async (params = {}) => Api.createResponse('auth/check-user',params);
	static register = async (params = {}) => Api.createResponse('auth/register',params);
	static readDocument = async (params = {}) => Api.createResponse('auth/read-document',params);
	static finishRegister = async (params = {}) => Api.createResponse('auth/finish-register',params);
	static getTerms = async (params = {}) => Api.createResponse('auth/terms',params);

}

export default AuthService;